<template>
  <div>
    <div v-if="resources.length > 0 && !loadingResources" class="flex flex-wrap items-stretch -mx-3 mt-5">
      <div v-for="item in resources" :key="item.id" class="w-full mb-6 md:w-1/2 lg:w-1/3 px-3">
        <resource-card :resource="item" @update="getResourcesPaged" />
      </div>
    </div>
    <div v-else-if="loadingResources" key="loading" class="flex justify-center py-10">
      <d-loader />
    </div>
    <div v-else key="empty" class="text-center py-10">
      <p>There are no resources available for you at this time.</p>
    </div>
    <div class="flex justify-end">
      <d-pagination :total="total" :per-page="pagination.pageSize" :current="pagination.page" @change="page => pagination.page = page" />
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import debounce from 'lodash/debounce';
  import { mapGetters } from 'vuex';
  import DPagination from '@devsquared/d2kit/src/js/elements/DPagination/DPagination.vue';

  export default {
    name: 'ResourcePage',
    parent: true,
    components: {
      DPagination,
    },
    props: {
      filter: String,
    },

    data() {
      return {
        resources: [],
        loadingResources: false,
        total: 0,
        pagination: {
          page: 1,
          pageSize: 18,
          sortField: 'createdAt',
          sortOrder: 'desc',
        },
      };
    },

    computed: {
      ...mapGetters('d2Auth', ['profile']),
    },

    watch: {
      pagination: {
        handler() {
          this.getResourcesPaged();
        },
        deep: true,
      },
      filter() {
        this.loadingResources = true;
        this.debounceGetResourcesPaged();
      },
    },

    mounted() {
      this.getResourcesPaged();
    },

    methods: {
      async getResourcesPaged() {
        const {
          page, sortField, sortOrder, pageSize,
        } = this.pagination;
        const params = [`filter=${this.filter}`, `sortDir=${sortField} ${sortOrder}`, `currentPage=${page}`, `pageSize=${pageSize}`].join('&');
        this.loadingResources = true;
        const { data } = await axios.get(`/api/resources/paged?${params}`);
        this.resources = data.resultItems;
        this.total = data.totalRecords;
        this.loadingResources = false;
      },

      debounceGetResourcesPaged: debounce(function () {
        this.getResourcesPaged ();
      }, 300),

      onSort(field, order) {
        this.pagination.sortField = field;
        this.pagination.sortOrder = order;
      },
    },
  };
</script>